import React from 'react';
import classnames from 'classnames';

import './spinner.scss';

type Props = {
  position?: 'inline' | 'cover',
  size?: 'tiny' | 'small',
  color?: 'light',
  className?: string
};

const Spinner = ({
  position,
  size,
  color,
  className
}: Props) => {
  const classes = classnames({
    spinner: true,
    [`spinner--position-${position}`]: position,
    [`spinner--color-${color}`]: color,
    [`spinner--size-${size}`]: size,
    [`${className}`]: Boolean(className)
  });

  return (
    <section
      className={classes}
      data-qa="spinner"
    >
      <div className="spinner__element" />
    </section>
  );
};

export default Spinner;
